module.exports = __webpack_public_path__ + "img/carson_bard.4238cdaf.png";